<template>
    <div id="listRate">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <div class="page-title"> User List</div>
                    <!-- Button for Clear Cache -->
                    <clear-cache-data :pageKey="[pageKey]" ></clear-cache-data>
                    <div class="web-action-btn btn-groups text-right">
                        <!-- commented because of not working
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="openModal()" >
                            <i class="fp-import"></i> Import
                        </a> -->
                        <a href="javascript:void(0)" class="btn btn-secondary" v-on:click="exportCheck()">
                            <i class="fp-export"></i> Export
                        </a>
                        <router-link v-if="canCreateUser" class="btn btn-primary" v-bind:to="{name: 'UserCreate'}" >
                            <i class="fp-add"> </i> Add
                        </router-link>
                    </div>
                </div>
                <div class="container-fluid">
                    <!-- Add Active / Inactive tab  -->
                    <div class="btn-groups badge-buttons text-left mb-3">
                            <div class="">
                                <div id="divTabMenu" class="btn-group rental-btn-grup-left" role="group" aria-label="Basic example">
                                    <button type="button" id="getActiveUserList"  v-on:click="getActiveUserList(this)" :class="'btn btn-secondary '+ activeSelected"> Active </button>
                                    <button type="button" id="getInactiveUserList"  v-on:click="getInActiveUserList(this)" :class="'btn btn-secondary '+ inactiveSelected"> Inactive </button>
                                </div>
                            </div>
                        </div>
                    <!--page content-->
                    <div class="admin-page-content user-lists">
                        <data-table-filter-config :moduleName="'userList'" ref="filterUser" @cancelSelection="cancelAll" :allowSameFilter="'allow'"></data-table-filter-config>
                        <p v-if="batchProcess" class="alert-success p-2" id="processFetchBatchMsg">Export file is in process.
                            batch no. is {{ batchNum }}.
                            <router-link class="color-blue" v-bind:to="{name: 'BatchList'}" target="_blank"
                                        @click.native="batchProcess = 0"> Click Here
                            </router-link>
                            to check file status!
                        </p>
                        <section class="data-table bg-white">
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange" :moduleName="'userList'" :position="'top'">
                                </custom-pagination>
                                <vue-good-table
                                        mode="remote"
                                        ref="userList"
                                        @on-page-change="onPageChange"
                                        @on-sort-change="onSortChange"
                                        @on-column-filter="onColumnFilter"
                                        @on-per-page-change="onPerPageChange"
                                        :totalRows="totalRecords"
                                        title="Users"
                                        :columns="userColumns"
                                        :rows="rows"
                                        :paginate="true"

                                        :paginationOptions="{
                                            enabled: false,
                                            position: 'both',
                                            perPage: perPage,
                                            perPageDropdown:dropDownPerPage,
                                            dropdownAllowAll: false,
                                        }"
                                        :select-options="{
                                            enabled: true,
                                            selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                                            selectionInfoClass: 'custom-class',
                                            selectionText: 'rows selected',
                                            clearSelectionText: 'clear',
                                        }"
                                        :sort-options="{
                                            enabled: true,
                                        }"
                                    >
                                    <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                                        <div :key="key">
                                            <div v-if="props.column.field == 'action'">
                                                <router-link v-if="canUpdateUser" title="Edit User" v-bind:key="'action' + key" class="fp-edit" v-bind:to="{name: 'UserEdit',params:{id:props.row.id}}"></router-link>
                                                <template v-if="changeUserStatus">
                                                    <template v-if="props.row.is_active == 'Inactive'">
                                                        <a href="#" v-on:click.prevent="changeStatus(props.row.id)" class="ml-3">
                                                            <span title="Activate User" class="fp-ok-icon color-green" style="font-size:16px;"></span>
                                                        </a>
                                                    </template>
                                                    <template v-else>
                                                        <a href="#" v-on:click.prevent="changeStatus(props.row.id)" class="ml-3">
                                                            <span title="Deactivate User" class="fp-closed color-red"></span>
                                                        </a>
                                                    </template>
                                                </template>
                                                <a href="#" v-if="changeUserStatus" v-on:click.prevent="changePassword(props.row.id)" class="ml-3">
                                                   <span title="Change Password" class="fp-settings mr-3 color-green" style="font-size:16px;"></span>
                                                </a>
                                            </div>
                                            <div v-else-if="props.column.field == 'first_name'">
                                                  <router-link v-if="canUpdateUser == true"  title="View User" class="color-blue" v-bind:to="{name: 'UserView',params:{id:props.row.id}}">{{ props.row.first_name }}</router-link>
                                              </div>
                                            <div v-else>
                                                {{props.formattedRow[props.column.field]}}
                                            </div>
                                        </div>
                                    </template>
                                </vue-good-table>
                                <custom-pagination
                                    :page-changed="onPageChange"
                                    :per-page-changed="onPerPageChange">
                                </custom-pagination>
                        </section>

                        <div class="modal fade user-upload-modal" id="user-upload-modal" ref="user-upload-modal" data-backdrop="static" data-keyboard="false" aria-labelledby="user-upload-modal" aria-hidden="true">
                            <div class="modal-dialog" role="document">
                                <div class="modal-content">
                                    <div class="modal-header">
                                        <h5 class="modal-title">Select File</h5>
                                    </div>
                                    <div class="modal-body">
                                        <form id="importIFTAFile" class="addinspectionForm">
                                            <div class="form-row">
                                                <div class="col form-group">
                                                    <label class="control-label require mb-2" for="name">File:</label><br/>
                                                    <input id="partUploadFile" type="file" @change="onFileChanged">
                                                    <div class="field-error">{{import_error}}</div>
                                                </div>
                                            </div>
                                            <div class="form-row">
                                                <div class="col form-group" v-if="fileName != ''">
                                                    <label class="control-label"> Download Sample file </label>
                                                    <a href="javascript:void(0)" v-on:click="generateExcelSample()"> <i class="fp-text-document"></i> {{fileName}} </a>
                                                </div>
                                            </div>

                                            <p v-if="importedCount > 0"><i class="fa fa-check" aria-hidden="true"></i> &nbsp;<strong>{{importedCount}} Records imported</strong></p>
                                        </form>

                                        <div class="modal-footer">
                                            <button class="btn btn-tertiary" id="cancelButton" data-dismiss="modal"> <i class="fp-close"> </i>Cancel</button>
                                            <button class="btn btn-primary" id="importButton" v-on:click="importParts()"> <i class="fp-import"> </i> Import</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
        <div class="modal fade add-extra-charge-popup" id="changePasswordModal" ref="changePasswordModal" data-backdrop="static" data-keyboard="false" aria-labelledby="changePasswordModal" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="myModal1">Change Password</h5>
                    </div>
                    <div class="modal-body">
                        <form id="SelectDates" class="addinspectionForm">
                            <div class="form-row row-cols-md-1 row-cols-1">
                                <div class="col form-group">
                                    <label class="control-label require">New Password</label>
                                    <div class="input-group">
                                        <input type="password" placeholder="Password" id="password" name="password" v-model="password" aria-describedby="basic-addon3" class="form-control"/>
                                    </div>
                                    <div class="field-error">{{password_error_msg}}</div>
                                </div>
                                <div class="col form-group">
                                    <label class="control-label require">Confirm Password</label>
                                    <div class="input-group">
                                        <input type="password" placeholder="Confirm Password" id="con_password" name="con_password" v-model="con_password" aria-describedby="basic-addon3" class="form-control"/>
                                    </div>
                                    <div class="field-error">{{con_password_error_msg}}</div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div class="modal-footer">
                        <button class="btn btn-primary" id="addChangePasswordBtn" v-on:click="resetPassword()">
                            <i class="fp-submit"></i> Reset
                        </button>
                        <button type="button" class="btn btn-tertiary" id="cancelChangePasswordBtnBtn" v-on:click="hideChangePasswordModal()">
                            <i class="fp-close"></i> Cancel
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import EventBus from "./event-bus";
    import Vue from 'vue';







    import {commonMixins} from '../mixins/commonMixins';
    import {dataTableMixins} from '../mixins/dataTableMixins';

    export default {
        name: "listUser",
        metaInfo() {
            return {
                title: "User List | " +process.env.COPYRIGHT_NAME
            }
        },
        mixins:[commonMixins,dataTableMixins],
        data: () => ({
             permissions: [],
            cantAccessPage: "",
            firstLoad : 0,
            userColumns:[],
            activeSelected:'',
            inactiveSelected:'',
            columns: [
                {
                    label: 'Actions',
                    field: 'action',
                    sortable: false,
                },
                {
                    label: 'Name',
                    field: 'first_name',
                    filterable: true,
                    fpFieldType:"text",
                    hidden:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Username',
                    field: 'username',
                    filterable: true,
                    hidden:false,
                    fpFieldType:"text",
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Username", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Email',
                    field: 'email',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Email", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Phone',
                    field: 'work_phone',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Phone", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Role',
                    field: 'role',
                    fpFieldType:"text",
                    hidden:false,
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Role", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Status',
                    field: 'is_active',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    html: false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "All", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: ['Active', 'Inactive'], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Location',
                    field: 'location',
                    fpFieldType:"option",
                    hidden:false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Location", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'City',
                    field: 'city',
                    fpFieldType:"text",
                    hidden:false,
                    html: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "City", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'State/Province',
                    field: 'state',
                    fpFieldType:"text",
                    hidden:false,
                    html: false,
                    filterable: true,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "State", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        filterDropdownItems: [], // dropdown (with selected values) instead of text input
                        filterFn: this.onColumnFilter, //custom filter function that
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },

            ],
            rows: [],
            totalRecords: 0,
            loading:false,
            changeUserStatus:false,
            canCreateUser:false,
            canUpdateUser:false,
            pageKey:"_user_list_",
            change_user_id:'',
            password:'',
            con_password:'',
            password_error_msg:'',
            con_password_error_msg:'',
            importedCount:0,
            import_error:'',
            fileName:'UserUpload',
            action: 'list',
            batchProcess: 0,
            batchNum: "",
        }),
        watch: {
            //check permission change
            permissions: function (permissions) {
                var self = this;
                if (permissions.length > 0) {
                    for (var i = 0; i < permissions.length; i++) {
                        if (permissions[i].name == 'list_user') {
                            self.cantAccessPage = true;
                        }
                        if (permissions[i].name == 'add_user') {
                            self.canCreateUser = true;
                            self.canUpdateUser = true;
                        }
                        if (permissions[i].name == 'active_inactive_user_status') {
                            self.changeUserStatus = true;
                        }
                    }
                }

            }
        },
        mounted: function () {

            var self = this;

            //load list of card rate
            //self.loadList();
            self.getPermissions();
            $('#divTabMenu button').removeClass("active");
            var prevSelectedTab = localStorage.getItem("user_list_prev_tab");
            if ( prevSelectedTab == null ) {
                self.flag = "active";
                self.activeSelected = 'active';
                localStorage.setItem('contract_list_prev_tab', 'active');
            }else {
                if ( prevSelectedTab == 'inactive' ) {
                    self.flag = "inactive";
                    self.inactiveSelected = 'active';
                }else {

                    self.flag = "active";
                    self.activeSelected = 'active';
                }
            }

        },
        methods: {
            cancelAll: function (cancelAll) {
              this.$refs.userList.unselectAllInternal();
            },

            changeStatus(id){

                var self = this;
                if (confirm('Are you sure that you want to Change User Status!')) {
                    self.loading = true;

                    $.ajax({
                        url: process.env.ROOT_API + "/user-status-change",
                        type: "POST",
                        data: {id: id},
                        headers: this.ajxHeaders,
                        dataType: 'json',
                        success: function (data) {
                            self.loading = false;
                            if (data.code == '200') {
                                self.loadList();
                            }
                        },
                        error: function (jqXHR, exception) {
                            self.loading = false;
                            self.generateStatusCodeMessage(jqXHR,true,'user-list-change-status')
                        }
                    });
                }
            },
            /*updateParams(newProps) {
                this.serverParams = Object.assign({}, this.serverParams, newProps);
            },
            onPageChange(params) {
                this.updateParams({page: params.currentPage});
                this.loadList();
            },
            onPerPageChange(params) {
                this.serverParams.page=1;
                this.updateParams({perPage: params.currentPerPage});
                this.totalRecords = self.totalRecords;
                this.loadList();
            },

            onColumnFilter(params) {
                this.updateParams(params);
                {
                    field:('first_name');
                    field:('username');
                    field:('email');
                    field:('work_phone');
                    field:('role');
                    field:('is_active');
                    field:('city');
                    field:('state');
                };
                var filtersPr = JSON.parse(JSON.stringify(this.serverParams));
                var filters = filtersPr.columnFilters;
                if (this.firstLoad == 1 || filters.first_name || filters.username || filters.email || filters.work_phone || filters.role || filters.is_active || filters.city || filters.state) {
                    this.loadList();
                }
            },*/
            selectionChanged(param) {
                var self = this;
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                // console.log(self.computed.selectedRows);
                // var rowData = self.$refs['my-table'].selectedRows;
                // console.log(rowData);
            },
            /*onSortChange(params) {
                this.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field,
                    },
                });
                this.loadList();
            },*/

            loadList(){
                var self = this;
                self.loading = true;

                var selectedRows = [];
                if (self.firstLoad == 1) {
                    //because on first load list not initialize
                    var data = this.$refs['userList'].selectedRows;
                    if(data.length > 0){
                        for (var i = 0; i < data.length; i++) {
                            selectedRows.push(this.$refs['userList'].selectedRows[i].id)
                        }
                    }
                }

                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/user/list",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    data:{
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        sort: self.serverParams.sort,
                        flag:self.flag,
                        selectedRows: selectedRows,
                        action: self.action,
                        selectedAll: self.serverParams.selectedAll
                    },
                    success: function (data) {
                        self.loading = false;
                        if (data.status == "success") {
                            if (self.action == "export" || self.action == "export_queue") {
                                if (data.code == "201") {
                                    alert(data.message);
                                } else {
                                    if (self.action == "export") {
                                        var save = document.createElement("a");
                                        save.href = data.content;
                                        save.download = data.content;
                                        save.target = "_blank";

                                        document.body.appendChild(save);
                                        save.click();
                                        document.body.removeChild(save);
                                    } else {
                                        self.batchProcess = 1;
                                        self.batchNum = data.content;
                                    }
                                }
                                self.action = "list";
                            } else {
                                self.rows = data.content.row;
                                self.totalRecords = data.content.totalRecords;
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        if (self.action == 'export' || self.action == 'export_queue') {
                            self.generateStatusCodeMessage(jqXHR,false,'user-export-error')
                        } else {
                            self.generateStatusCodeMessage(jqXHR,false,'user-list-error')
                        }
                    }
                });
            },

            changePassword: function(uId){
                var self = this;

                self.password = '';
                self.con_password = '';
                self.password_error_msg = '';
                self.con_password_error_msg = '';
                self.change_user_id = uId;
                $("#changePasswordModal").modal('show');
            },

            hideChangePasswordModal: function(){
                var self = this;

                self.password = '';
                self.con_password = '';
                self.password_error_msg = '';
                self.con_password_error_msg = '';
                self.change_user_id = '';
                $("#changePasswordModal").modal('hide');
            },

            resetPassword: function() {

                var self = this;
                var error = false;
                self.password_error_msg = "";
                self.con_password_error_msg = "";

                if (!self.password) {
                    self.password_error_msg = "";
                    self.password_error_msg = self.passReq;
                    error = true;
                }

                if (self.password && self.password.length < 8) {
                    self.password_error_msg = "";
                    self.password_error_msg = self.passLengthErr;
                    error = true;
                }
                if (!self.con_password) {
                    self.con_password_error_msg = "";
                    self.con_password_error_msg = self.confPassReqErr;
                    error = true;
                }
                if (self.password && self.password != self.con_password) {
                    self.con_password_error_msg = "";
                    self.con_password_error_msg = self.confPassMatchErr;
                    error = true;
                }

                if (
                   !error
                ) {
                    self.loading = true;

                    $.ajax({
                    url: process.env.ROOT_API + "/user/change_password",
                    type: "POST",
                    crossDomain: true,
                    headers: this.ajxHeaders,
                    data: {
                        email: self.change_user_id,
                        password: self.password,
                        confirmPassword: self.con_password,
                        from:'admin'
                    },
                    dataType: "json",
                    success: function(data) {
                        self.loading = false;
                        if (data.status == "success") {
                            self.con_password = "";
                            self.password = "";

                            self.$swal("", "Password Changed Successfully", "success");
                            $("#changePasswordModal").modal('hide');
                        }
                        if (data.code == 201) {
                            self.error = data.message;
                        }
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        console.log(jqXHR.responseJSON);
                        if (jqXHR.status == 0) {
                            self.error = "Remote server cannot be reached";
                        } else {
                            self.error = jqXHR.responseJSON;
                            self.replybtn = "Send";
                        }
                    }
                    });
                }
            },
            getActiveUserList: function(){
                console.log("active");
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getActiveUserList").addClass("active");
                self.activeSelected = "active";
                self.inactiveSelected = "";
                localStorage.setItem('user_list_prev_tab', 'active');
                self.flag = 'active';
                self.loadList();

            },
            getInActiveUserList: function(){
                console.log("inactive");
                var self = this;
                $('#divTabMenu button').removeClass("active");
                $("#getInactiveUserList").addClass("active");
                self.activeSelected = "";
                self.inactiveSelected = "active";
                localStorage.setItem('user_list_prev_tab', 'inactive');
                self.flag = 'inactive';
                self.loadList();

            },
            openModal: function(){
                let self = this;
                self.importedCount = 0;
                self.selectedFile = "";
                $("#partUploadFile").val('');
                self.import_error = '';
                $('#user-upload-modal').modal('show');
            },
            onFileChanged(event) {
                const file = event.target.files[0];
                let self = this;
                self.selectedFile = file;
                self.import_error = '';
            },
            generateExcelSample() {
                let self = this;
                self.loading = true;
                $.ajax({
                    url:
                    process.env.ROOT_API + "/user-excel/generate",
                    type: "POST",
                    crossDomain: true,
                    dataType: "json",
                    headers: this.ajxHeaders,
                    success: function(data) {
                        self.loading = false;
                        self.file = data.content.web;

                        let docPath = self.file;
                        let save = document.createElement('a');
                        save.href = docPath;
                        save.download = docPath;
                        save.target = '_blank';
                        document.body.appendChild(save);
                        save.click();
                        document.body.removeChild(save);
                    },
                    error: function(jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'part-upload-generate')

                    }
                });
            },
            importParts() {
                let self = this;
                self.import_error = "";

                if( self.selectedFile == "" || self.selectedFile == null){
                    self.import_error = "Please Select Excel File.";
                    return;
                }
                let fileExtension = ['xls', 'xlsx'];
                if ($.inArray(self.selectedFile.name.split('.').pop().toLowerCase(), fileExtension) == -1) {
                    self.import_error = "Only formats are allowed : "+fileExtension.join(', ');
                    return;
                }

                let formData = new FormData();
                formData.append('myFile', self.selectedFile);

                self.loading = true;
                $('#importButton').text('Fetching...');
                $('#importButton').prop('disabled',true);
                $('#cancelButton').prop('disabled',true);

                $.ajax({
                    url: process.env.ROOT_API + "/user-excel/import",
                    type: "POST",
                    data: formData,
                    headers: this.ajxHeaders,
                    crossDomain: true,
                    processData: false,
                    contentType: false,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.import_error = '';
                        if (data.code == 201) {
                            self.import_error = data.message;
                            return;
                        }
                        if (data.status == "success") {
                            if ( Object.keys(data.duplicate).length > 0){
                                self.importedCount = data.content;
                            }else{
                                if(data.content){
                                    self.$swal('',data.content+" Records imported",'success');
                                }
                                $('#user-upload-modal').modal('hide');
                                self.loadList();
                            }
                        }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        $('#importButton').text('Import');
                        $('#importButton').prop('disabled',false);
                        $('#cancelButton').prop('disabled',false);
                        self.generateStatusCodeMessage(jqXHR,true,'user-upload-import-error')
                    }
                });
            },
            exportCheck: function () {
                var count = 0;
                var actionFlag = "";
                var data = this.$refs['userList'].selectedRows;
                count = data.length;

                if (this.serverParams.selectedAll == true) {
                    actionFlag = "";
                } else if (count != 0 && count <= 100) {
                    actionFlag = "export";
                }

                this.exportReports(actionFlag);
            },
        }
    };
</script>




// WEBPACK FOOTER //
// src/components/UserList.vue